/* ===== Sticky Add To Cart (working version) ===== */

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.sticky = this;
    this.stickyBounds =
      document.getElementById('product-add-to-cart') ||
      document.querySelector('[data-combo-addtocart]');
    this.closeSticky = this.querySelector('[data-close-sticky-add-to-cart]');
    this.expandSticky = this.querySelector('[data-expand-sticky-add-to-cart]');

    this.closeSticky?.addEventListener('click', this.setCloseSticky.bind(this));
    this.expandSticky?.addEventListener('click', this.setExpandSticky.bind(this));

    this.openStickyButton = document.getElementById('show-sticky-product');
    this.closeModal = this.closeStickyModal.bind(this);
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.openStickyButton?.addEventListener('click', this.openStickyModal.bind(this));
    document.addEventListener('click', (e) => {
      if (
        e.target.matches('.background-overlay') ||
        e.target.closest('[data-close-sticky-mobile]') != null ||
        e.target.matches('[data-close-sticky-mobile]')
      ) {
        this.closeModal();
      }
    });
  }

  openStickyModal() {
    document.body.classList.add('show-mobile-options');
    const container = this.closest('[data-sticky-add-to-cart]');
    if (!container) return;
    const height = container.clientHeight || 0;
    const panel = this.sticky.querySelector('.sticky-product-mobile');
    if (panel) panel.style.bottom = height + 'px';
  }

  closeStickyModal() {
    document.body.classList.remove('show-mobile-options');
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let offsetScroll;

    if (this.stickyBounds != null) {
      // jQuery measurements kept to preserve theme behavior
      offsetScroll =
        $(this.stickyBounds).offset().top + $(this.stickyBounds).outerHeight(true) + 100;
    } else {
      offsetScroll = 0;
    }

    const winHeight = window.innerHeight;
    const docHeight = document.body.clientHeight;

    if (scrollTop > offsetScroll && scrollTop + winHeight < docHeight) {
      requestAnimationFrame(this.show.bind(this));

      if (this.sticky.classList.contains('style-1')) {
        let height = 0;
        const previewBar = document.getElementById('preview-bar-iframe');
        const toolbarMobile = document.querySelector('.halo-sticky-toolbar-mobile');

        if (previewBar && window.getComputedStyle(previewBar).display !== 'none') {
          height = previewBar.offsetHeight;
        } else if (toolbarMobile) {
          height = toolbarMobile.offsetHeight;
        }

        this.sticky.style.top = 'auto';
        this.sticky.style.bottom = `${height}px`;
        document
          .querySelector('.quick-order-list__total')
          ?.style.setProperty('bottom', `${height + this.offsetHeight}px`);
      } else if (this.sticky.classList.contains('style-2')) {
        if (document.body.classList.contains('scroll-up')) {
          let height = document.querySelector('sticky-header')?.offsetHeight || 0;
          if (window.innerWidth < 551) height = height + 20;
          this.sticky.style.top = `${height}px`;
        } else if (document.body.classList.contains('scroll-down')) {
          if (window.innerWidth > 550) {
            this.sticky.style.top = 0;
          } else {
            this.sticky.style.top = '20px';
          }
        }
      }
    } else {
      requestAnimationFrame(this.hide.bind(this));
      if (this.sticky.classList.contains('style-1'))
        document
          .querySelector('.quick-order-list__total')
          ?.style.setProperty('bottom', '0px');
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.sticky.classList.remove('show-sticky', 'hidden-sticky', 'full-sticky', 'animate');
    document.body.classList.remove('show-mobile-options');
  }

  show() {
    this.sticky.classList.add('show-sticky', 'animate');
  }

  setCloseSticky(event) {
    event.preventDefault();
    if (this.sticky.classList.contains('full-sticky')) {
      this.sticky.classList.remove('full-sticky');
    } else {
      this.sticky.classList.add('hidden-sticky');
    }
  }

  setExpandSticky(event) {
    event.preventDefault();
    this.sticky.classList.add('full-sticky');
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);

/* ===== Variant handlers (Selects) ===== */

class VariantStickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.item = $(this).closest('.productView');
    this.sticky = $(this).closest('.productView-stickyCart');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  connectedCallback() {
    // Initial sync so the sticky reflects the correct state on first paint
    try {
      this.updateOptions();
      this.updateMasterId();
      if (!this.currentVariant) return;

      this.updateVariantInput();
      this.updatePickupAvailability();
      this.updateMedia(200);
      this.updateURL();
      this.renderProductAjaxInfo();
      this.renderProductInfo();
      this.updateAttribute(!this.currentVariant.available);
    } catch (e) {
      console.warn('Sticky selects init failed', e);
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant) return;

    this.updatePickupAvailability();
    this.updateMedia(200);
    this.updateURL();
    this.updateVariantInput();
    this.renderProductAjaxInfo();
    this.renderProductInfo();
    this.updateAttribute(!this.currentVariant.available);
  }

  /* Option helpers (selects) */
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  decodeOptions() {
    this.options = this.options.map((option) => this.decodeOption(option));
  }

  decodeOption(option) {
    if (option) {
      return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/');
    }
    return null;
  }

  encodeOption(option) {
    if (option) {
      return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash');
    }
    return null;
  }

  /* IMPORTANT FIX: find currentVariant by comparing options */
  updateMasterId() {
    this.decodeOptions();
    const variants = this.getVariantData();
    this.currentVariant = variants.find((variant) => {
      // variant.options is an array [opt1, opt2, opt3]
      return !variant.options
        .map((opt, idx) => this.options[idx] === opt)
        .includes(false);
    });
  }

  updateMedia(time) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const itemImage = this.item.find('.sticky-image');
    const image = this.currentVariant?.featured_image;
    if (!itemImage?.length || !image) return;

    itemImage.find('img').attr({
      src: image.src,
      srcset: image.src,
      alt: image.alt,
    });

    const newMedia = document.querySelectorAll(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia?.length) return;

    window.setTimeout(() => {
      $(newMedia).trigger('click');
    }, time);
  }

  updateURL() {
    if (!this.currentVariant) return;
    try {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    } catch (e) {}
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}, #product-form-sticky-${this.dataset.product}`
    );

    productForms.forEach((productForm) => {
      const input = productForm?.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductAjaxInfo() {
    if (!this.currentVariant) return;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `product-price-${this.dataset.product}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        if (this.checkNeedToConvertCurrency()) {
          let currencyCode = document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');
          Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
        }

        document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove(
          'visibility-hidden'
        );
      })
      .catch(() => {});
  }

  renderProductInfo() {
    const variants = this.getVariantData();
    if (!variants?.length || !this.currentVariant) return;

    const variantList = variants.filter((v) => v.available);
    const selectedOption1 = this.currentVariant?.option1;
    const selectedOption2 = this.currentVariant?.option2;
    const selectedOption3 = this.currentVariant?.option3;

    const options = this.item.find('.product-form__input:not(.mobile)');
    const optionsMobile = this.item.find('.product-form__input.mobile');

    const renderOptions = (opts) => {
      $.each(opts, (index, element) => {
        const position = $(element).data('option-index');
        const type = $(element).data('product-attribute');

        const syncSelect = (el, value) => {
          if (type == 'set-select') {
            $(el).find('.select__select').val(value);
            const selectList = $(el).find('.select__select option');
            selectList.each((idx, opt) => {
              if (opt.value == value) $(opt).attr('selected', 'selected');
              else $(opt).removeAttribute?.('selected'); // for regular DOM Option
            });
          } else {
            $(el).find('.product-form__radio').prop('checked', false);
            $(el)
              .find(`.product-form__radio[value="${this.encodeOption(value)}"]`)
              .prop('checked', true)
              .trigger('change');
          }
        };

        switch (position) {
          case 0: {
            $(element).find('[data-header-option]').text(selectedOption1);
            syncSelect(element, selectedOption1);

            const option1List = variantList.filter((v) => v.option1 === selectedOption1);

            if (selectedOption2) {
              const inputList = $(options[1]);
              const inputs = inputList.find('.product-form__radio');
              const selectOptions = inputList.find('.select__select option');

              if (type == 'set-rectangle') {
                inputs.each((idx, elt) => {
                  const $label = $(elt).next();
                  const value = this.decodeOption($(elt).val());
                  const exists = option1List.find((v) => v.option2 == value);
                  $label.toggleClass('available', !!exists).toggleClass('soldout', !exists);
                });
              } else {
                selectOptions.each((idx, opt) => {
                  const value = this.decodeOption($(opt).val());
                  const exists = option1List.find((v) => v.option2 == value);
                  if (exists) $(opt).removeAttr('disabled');
                  else $(opt).attr('disabled', true);
                });
              }
            }

            if (selectedOption3) {
              const inputList = $(options[2]);
              const inputs = inputList.find('.product-form__radio');
              const selectOptions = inputList.find('.select__select option');

              if (type == 'set-rectangle') {
                inputs.each((idx, elt) => {
                  const $label = $(elt).next();
                  const value = this.decodeOption($(elt).val());
                  const exists = option1List.find((v) => v.option3 == value);
                  $label.toggleClass('available', !!exists).toggleClass('soldout', !exists);
                });
              } else {
                selectOptions.each((idx, opt) => {
                  const value = this.decodeOption($(opt).val());
                  const exists = option1List.find((v) => v.option3 == value);
                  if (exists) $(opt).removeAttr('disabled');
                  else $(opt).attr('disabled', true);
                });
              }
            }
            break;
          }

          case 1: {
            $(element).find('[data-header-option]').text(selectedOption2);
            syncSelect(element, selectedOption2);

            const option2List = variantList.filter((v) => v.option2 === selectedOption2);

            if (selectedOption1) {
              const inputList = $(options[0]);
              const inputs = inputList.find('.product-form__radio');
              const selectOptions = inputList.find('.select__select option');

              if (type == 'set-rectangle') {
                inputs.each((idx, elt) => {
                  const $label = $(elt).next();
                  const value = this.decodeOption($(elt).val());
                  const exists = option2List.find((v) => v.option1 == value);
                  $label.toggleClass('available', !!exists).toggleClass('soldout', !exists);
                });
              } else {
                selectOptions.each((idx, opt) => {
                  const value = this.decodeOption($(opt).val());
                  const exists = option2List.find((v) => v.option1 == value);
                  if (exists) $(opt).removeAttr('disabled');
                  else $(opt).attr('disabled', true);
                });
              }
            }

            if (selectedOption3) {
              const inputList = $(options[2]);
              const inputs = inputList.find('.product-form__radio');
              const selectOptions = inputList.find('.select__select option');

              if (type == 'set-rectangle') {
                inputs.each((idx, elt) => {
                  const $label = $(elt).next();
                  const value = this.decodeOption($(elt).val());
                  const exists = option2List.find((v) => v.option3 == value);
                  $label.toggleClass('available', !!exists).toggleClass('soldout', !exists);
                });
              } else {
                selectOptions.each((idx, opt) => {
                  const value = this.decodeOption($(opt).val());
                  const exists = option2List.find((v) => v.option3 == value);
                  if (exists) $(opt).removeAttr('disabled');
                  else $(opt).attr('disabled', true);
                });
              }
            }
            break;
          }

          case 2: {
            $(element).find('[data-header-option]').text(selectedOption3);
            syncSelect(element, selectedOption3);

            const option3List = variantList.filter((v) => v.option3 === selectedOption3);

            if (selectedOption1) {
              const inputList = $(options[0]);
              const inputs = inputList.find('.product-form__radio');
              const selectOptions = inputList.find('.select__select option');

              if (type == 'set-rectangle') {
                inputs.each((idx, elt) => {
                  const $label = $(elt).next();
                  const value = this.decodeOption($(elt).val());
                  const exists = option3List.find((v) => v.option1 == value);
                  $label.toggleClass('available', !!exists).toggleClass('soldout', !exists);
                });
              } else {
                selectOptions.each((idx, opt) => {
                  const value = this.decodeOption($(opt).val());
                  const exists = option3List.find((v) => v.option1 == value);
                  if (exists) $(opt).removeAttr('disabled');
                  else $(opt).attr('disabled', true);
                });
              }
            }

            if (selectedOption2) {
              const inputList = $(options[1]);
              const inputs = inputList.find('.product-form__radio');
              const selectOptions = inputList.find('.select__select option');

              if (type == 'set-rectangle') {
                inputs.each((idx, elt) => {
                  const $label = $(elt).next();
                  const value = this.decodeOption($(elt).val());
                  const exists = option3List.find((v) => v.option2 == value);
                  $label.toggleClass('available', !!exists).toggleClass('soldout', !exists);
                });
              } else {
                selectOptions.each((idx, opt) => {
                  const value = this.decodeOption($(opt).val());
                  const exists = option3List.find((v) => v.option2 == value);
                  if (exists) $(opt).removeAttr('disabled');
                  else $(opt).attr('disabled', true);
                });
              }
            }
            break;
          }
        }
      });
    };

    renderOptions(options);
    renderOptions(optionsMobile);

    if (this.item.find('[data-sku]').length > 0) {
      this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku || '');
    }

    if (this.item.find('[data-barcode]').length > 0) {
      this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode || '');
    }

    const inventory = this.currentVariant?.inventory_management;
    if (inventory != null) {
      const arrayInVarName = `product_inven_array_${this.dataset.product}`;
      const inven_array = window[arrayInVarName];

      if (inven_array != undefined) {
        const inven_num = inven_array[this.currentVariant.id];
        const inputQuantity = this.item.find('input[name="quantity"]');
        const buttonSubmit = this.item.find('button#product-sticky-add-to-cart');
        const inventoryQuantity = parseInt(inven_num, 10);

        if (inputQuantity.length > 0) {
          inputQuantity.attr('data-inventory-quantity', inventoryQuantity);
        } else if (buttonSubmit.length > 0) {
          buttonSubmit.attr('data-inventory-quantity', inventoryQuantity);
        }

        if (this.item.find('[data-inventory]').length > 0) {
          if (inventoryQuantity > 0) {
            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
          } else {
            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
          }
        }

        if (this.item.find('.productView-hotStock').length > 0) {
          const hotStock = this.item.find('.productView-hotStock');
          const maxStock = hotStock.data('hot-stock');
          if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
            const textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            hotStock.text(textStock).show();
          } else {
            hotStock.hide();
          }
        }
      }
    }
  }

  updateAttribute(disable = true) {
    const mainForm = document.getElementById(`product-form-${this.dataset.product}`);
    const stickyForm = document.getElementById(`product-form-sticky-${this.dataset.product}`);

    // Robust button selectors (IMPORTANT FIX)
    const addButton =
      mainForm?.querySelector('[name="add"]') ||
      mainForm?.querySelector('button[type="submit"], [type="submit"]');

    const stickyButton =
      stickyForm?.querySelector('[name="add"]') ||
      stickyForm?.querySelector('button[type="submit"], [type="submit"]');

    const quantityInput = $('[data-sticky-add-to-cart] .quantity__input');
    let submitBtn = $('[data-sticky-add-to-cart] .product-form__submit');
    const notifyMe = this.item.find('.productView-notifyMe');

    let stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
    if (stickyPrice.length === 0) {
      stickyPrice = $('[data-sticky-add-to-cart] .sticky-price .money-subtotal');
    }

    let maxValue;
    if (quantityInput.length > 0) {
      maxValue = parseInt(quantityInput.attr('data-inventory-quantity'), 10);
    } else {
      maxValue = parseInt(submitBtn.attr('data-inventory-quantity'), 10);
    }
    if (!Number.isFinite(maxValue)) maxValue = 0;

    const setBtnText = (btn, text, disabled) => {
      if (!btn) return;
      if (disabled) btn.setAttribute('disabled', true);
      else btn.removeAttribute('disabled');
      btn.textContent = text;
    };

    if (disable) {
      const text = window.variantStrings?.soldOut || 'Sold out';

      this.item.removeClass('isChecked');
      quantityInput.attr('data-price', this.currentVariant?.price || 0);
      quantityInput.attr('disabled', true);

      setBtnText(addButton, text, true);
      setBtnText(stickyButton, text, true);

      if (notifyMe.length > 0) {
        notifyMe.find('.halo-notify-product-variant').val(this.currentVariant?.title || '');
        notifyMe.find('.notifyMe-text').empty();
        notifyMe.slideDown('slow');
      }
    } else {
      let text;
      let subTotal = 0;
      const price = this.currentVariant?.price || 0;

      if (window.subtotal?.show) {
        const qty = quantityInput.val() || 1;
        subTotal = qty * price;
        subTotal = Shopify.formatMoney(subTotal, window.money_format);
        subTotal = extractContent(subTotal);

        const moneySpan = document.createElement('span');
        moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
        moneySpan.innerText = subTotal;
        document.body.appendChild(moneySpan);

        if (this.checkNeedToConvertCurrency()) {
          let currencyCode = document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');
          Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
        }

        subTotal = moneySpan.innerText;
        $(moneySpan).remove();

        if (window.subtotal.style == '1') {
          const pdView_subTotal =
            document.querySelector('.productView-subtotal .money') ||
            document.querySelector('.productView-subtotal .money-subtotal');
          if (pdView_subTotal != null) {
            if ($('body').hasClass('disable_currencies')) {
              const node = document.querySelector('.productView-subtotal .money-subtotal');
              if (node) node.innerHTML = subTotal;
            } else {
              pdView_subTotal.textContent = subTotal;
            }
          }

          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == 'shopify'
          ) {
            text = window.variantStrings?.preOrder || 'Pre-order';
          } else {
            text = window.variantStrings?.addToCart || 'Add to cart';
          }
        } else if (window.subtotal.style == '2') {
          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == 'shopify'
          ) {
            text = window.variantStrings?.preOrder || 'Pre-order';
          } else {
            text = window.subtotal.text.replace('[value]', subTotal);
          }
        }
      } else {
        subTotal = Shopify.formatMoney(price, window.money_format);
        if (window.currencyFormatted) subTotal = $(subTotal).text();

        const moneySpan = document.createElement('span');
        moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
        moneySpan.innerText = subTotal;
        document.body.appendChild(moneySpan);

        if (this.checkNeedToConvertCurrency()) {
          let currencyCode = document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');
          Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
        }

        subTotal = moneySpan.innerText;
        $(moneySpan).remove();

        if (
          this.currentVariant.available &&
          maxValue <= 0 &&
          this.currentVariant.inventory_management == 'shopify'
        ) {
          text = window.variantStrings?.preOrder || 'Pre-order';
        } else {
          text = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      this.item.addClass('isChecked');
      quantityInput.attr('data-price', this.currentVariant?.price || 0);
      quantityInput.attr('disabled', false);

      setBtnText(addButton, text, false);
      setBtnText(stickyButton, text, false);

      if (subTotal != 0 && stickyPrice.length) {
        if ($('body').hasClass('disable_currencies')) {
          const stickySubtotal = $('[data-sticky-add-to-cart] .sticky-price .money-subtotal');
          stickySubtotal.html(subTotal);
        } else {
          stickyPrice.text(subTotal);
        }
      }

      const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
      const existingCompare = $('[data-sticky-add-to-cart] .money-compare-price');
      const compare_at_price = this.currentVariant?.compare_at_price;

      if (compare_at_price) {
        thisStickyPrice.addClass('has-compare-price');
        if (existingCompare.length) {
          existingCompare.attr('data-compare-price', compare_at_price);

          const compare_at_price_sticky = Shopify.formatMoney(compare_at_price, window.money_format);
          const comparePrice_sticky = extractContent(compare_at_price_sticky);
          existingCompare.text(comparePrice_sticky);

          if (this.checkNeedToConvertCurrency()) {
            let currencyCode = document
              .getElementById('currencies')
              ?.querySelector('.active')
              ?.getAttribute('data-currency');
            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
          }

          thisStickyPrice.prepend(
            `<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`
          );
          existingCompare.remove();
        } else {
          thisStickyPrice.prepend(
            `<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`
          );
        }
      } else {
        thisStickyPrice.removeClass('has-compare-price');
        existingCompare.remove();
      }

      const stickyCompareMoney = $('[data-sticky-add-to-cart] .money-compare-price .money');
      if (subTotal != 0 && stickyCompareMoney.length && window.subtotal?.show) {
        let comparePrice = Number(
          $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price') || 0
        );
        const qty = quantityInput.val() || 1;
        comparePrice = qty * comparePrice;
        comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
        comparePrice = extractContent(comparePrice);
        stickyCompareMoney.text(comparePrice);
      }

      if (notifyMe.length > 0) {
        notifyMe.slideUp('slow');
      }
    }

  // ...existing code that sets form buttons, subtotal, compare-at, notifyMe...
  this.syncMobileTrigger(disable)
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]')?.textContent || '[]');
    return this.variantData;
  }

  checkNeedToConvertCurrency() {
    const currencyItem = $('.dropdown-item[data-currency]');
    if (currencyItem.length) {
      // Keep existing theme logic
      return (
        (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) ||
        window.show_auto_currency
      );
    } else {
      return false;
    }
  }
}

customElements.define('variant-sticky-selects', VariantStickyAddToCart);

/* ===== Variant handlers (Radios) ===== */

class VariantStickyRadios extends VariantStickyAddToCart {
  constructor() {
    super();
    this.updateMediaTimeout = undefined;
  }

  connectedCallback() {
    // Initial sync for radios
    try {
      this.updateOptions();
      this.updateMasterId();
      if (!this.currentVariant) return;

      this.updateVariantInput();
      this.updatePickupAvailability();
      this.updateMedia(10);
      this.updateURL();
      this.updateSelectVariant();
      this.renderProductAjaxInfo();
      this.renderProductInfo();
      this.updateAttribute(!this.currentVariant.available);
    } catch (e) {
      console.warn('Sticky radios init failed', e);
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant) return;

    this.updatePickupAvailability();
    this.updateMedia(10);
    this.updateURL();
    this.updateVariantInput();
    this.updateSelectVariant();
    this.renderProductAjaxInfo();
    this.renderProductInfo();
    this.updateAttribute(!this.currentVariant.available);
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll('input')).find((r) => r.checked);
      return checked ? checked.value : null;
    });
  }

  updateSelectVariant() {
    const selectElement = this.closest('.productView-stickyCart')?.querySelector('select');
    if (selectElement && this.currentVariant) selectElement.value = this.currentVariant.id;
  }

  updateMasterId() {
    this.decodeOptions();
    const variants = this.getVariantData();
    this.currentVariant = variants.find((variant) => {
      return !variant.options
        .map((opt, idx) => this.options[idx] === opt)
        .includes(false);
    });
  }

  updateMedia(time) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const itemImage = this.item.find('.sticky-image');
    const image = this.currentVariant?.featured_image;
    if (!itemImage?.length || !image) return;

    itemImage.find('img').attr({
      src: image.src,
      srcset: image.src,
      alt: image.alt,
    });

    const newMedia = document.querySelectorAll(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia?.length) return;

    clearTimeout(this.updateMediaTimeout);
    this.updateMediaTimeout = setTimeout(() => {
      $(newMedia).trigger('click');
    }, time);
  }

  openStickyModal() {
    document.body.classList.add('show-mobile-options');
  }

  closeStickyModal() {
    document.body.classList.remove('show-mobile-options');
  }

/** Keep the mobile opener (#show-sticky-product) in sync with availability/Globo,
 * but only treat as "Coming Soon" if in the disponible-bientot collection
 * or Globo has rendered its Coming Soon button.
 */
syncMobileTrigger(disable) {
  const wrapper = document.querySelector('[data-sticky-add-to-cart] .empty-add-cart-button-wrapper');
  if (!wrapper) return;
  const trigger = wrapper.querySelector('#show-sticky-product');
  if (!trigger) return;

  // Always work relative to the sticky container
  const root = trigger.closest('[data-sticky-add-to-cart]') || document.querySelector('[data-sticky-add-to-cart]');

  // Clean any previous handlers we attached
  if (trigger.__blockHandler) { trigger.removeEventListener('click', trigger.__blockHandler); trigger.__blockHandler = null; }
  if (trigger.__bisScrollHandler) { trigger.removeEventListener('click', trigger.__bisScrollHandler); trigger.__bisScrollHandler = null; }

  // ---- helpers ----
  const getHandlesFromData = () => {
    const raw = root?.dataset?.collections || '';
    return raw.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  };
  const inCollection = (handle) => getHandlesFromData().includes((handle || '').toLowerCase());

  const globoComingSoonPresent = !!root?.querySelector('.gPreorderComingSoonBtnAddtocart');

  const isComingSoon = globoComingSoonPresent || inCollection('disponible-bientot');

  // ---- apply UI state ----
  if (disable && isComingSoon) {
    // COMING SOON
    const label =
      root?.querySelector('.gPreorderComingSoonBtnAddtocart')?.textContent?.trim() ||
      window.variantStrings?.comingSoon ||
      'Disponible bientôt';

    trigger.textContent = label;
    trigger.setAttribute('disabled', 'true');
    trigger.classList.add('product-form__na','gPreorderComingSoonBtn','gPreorderComingSoonBtnAddtocart');
    // prevent theme auto-labeler from flipping text back
    trigger.classList.remove('button-text-change');

    // Block opening the panel
    trigger.__blockHandler = (e) => { e.preventDefault(); e.stopImmediatePropagation(); };
    trigger.addEventListener('click', trigger.__blockHandler);

  } else if (disable && !isComingSoon) {
    // REGULAR OOS
    const label = window.variantStrings?.soldOut || 'En rupture de stock';
    trigger.textContent = label;
    trigger.removeAttribute('disabled');
    trigger.classList.remove('product-form__na','gPreorderComingSoonBtn','gPreorderComingSoonBtnAddtocart');

    // Optional: scroll to Back-in-Stock form
    trigger.__bisScrollHandler = (e) => {
      e.preventDefault();
      root?.querySelector('#Globo-Back-In-Stock')?.scrollIntoView({ behavior: 'smooth' });
    };
    trigger.addEventListener('click', trigger.__bisScrollHandler);

  } else {
    // AVAILABLE
    const addLabel = window.variantStrings?.addToCart || 'Ajouter au panier';
    trigger.textContent = addLabel;
    trigger.removeAttribute('disabled');
    trigger.classList.remove('product-form__na','gPreorderComingSoonBtn','gPreorderComingSoonBtnAddtocart');
  }
}

}

customElements.define('variant-sticky-radios', VariantStickyRadios);

/* ===== Utility (kept from your original) ===== */

function parseDoubleQuote(option, isDecoding = true) {
  if (!option) return option;
  if (isDecoding) {
    return option.replace('"', 'spc_dbl_qte');
  } else {
    return option.replace('spc_dbl_qte', '"');
  }
}